import Vue from 'vue'
import App from './App.vue'
import router from './router';
Vue.config.productionTip = false
import {safeFetch} from './common/api';
Vue.prototype.$fetch = safeFetch;
import './assets/css/reset.css';

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
